module.exports = __webpack_public_path__ + "img/ic-ic-new-man-b.3370eb4f.svg";